// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notification-class-many {\n  margin-bottom: -60px !important;\n}\n.notification-class {\n  margin-bottom: 16px !important;\n}\n.ant-notification {\n  z-index: 1051 !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
